import React, { useEffect, useState } from 'react'
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, Button, Box, Flex, Text, Select } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IAddBranchInPayroll, schema } from './model';
import { Dropdown } from '../../../../components/DropDown/DropDown';
import { CustomToast, CustomTable } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from '../../../../components/CustomTable/customTable';

interface AddBranchProps {
    isOpen: boolean;
    onClose: () => void;
    payrollCompany: any;
}

export default function AddBranch({ isOpen, onClose, payrollCompany }: AddBranchProps) {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [branches, setBranches] = useState<any[]>([]);
    const [companies, setCompanies] = useState<any[]>([]);
    const [tableData, setTableData] = useState<any[]>([]);
    const [saving, setSaving] = useState(false);
    const [statusChanges, setStatusChanges] = useState<{ [key: number]: boolean }>({});
    const [loadingId, setLoadingId] = useState<number | null>(null);


    const { control, handleSubmit, formState: { errors }, setValue, reset, watch } = useForm<IAddBranchInPayroll>({
        resolver: yupResolver(schema),
        defaultValues: {}
    });

    const loadCompanies = async () => {
        const response = await fetchApi("Dropdown/company", "GET");
        if (response) setCompanies(response);
    };

    const loadBranches = async (companyID?: number) => {
        if (!companyID) return;
        const response = await fetchApi(`Dropdown/branches?companyId=${companyID}`, "GET");
        if (response) setBranches(response);
    };

    const loadExistingBranches = async () => {
        if (!payrollCompany?.id) return;
        const response = await fetchApi(`Hrlense_PayrollCompany/PayrollCompanyBranch`, "GET", "", `payroll_Company_Id=${payrollCompany.id}`);
        if (response) setTableData(response);
    };

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === "company_Id") {
                setValue("branch_Id", 0, {
                    shouldValidate: true,
                    shouldDirty: true,
                });

                setBranches([]);

                if (value.company_Id && Number(value.company_Id) > 0) {
                    loadBranches(Number(value.company_Id));
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, setValue]);

    useEffect(() => {
        if (isOpen && payrollCompany) {
            loadCompanies();
            loadExistingBranches();
            reset();
        }
    }, [isOpen, payrollCompany]);

    const onSubmit = async (data: IAddBranchInPayroll) => {
        if (!payrollCompany?.id) return;
        setSaving(true);
        const payload = {
            company_Id: data.company_Id,
            branch_id: data.branch_Id,
            payroll_Company_Id: payrollCompany.id
        };
        const response = await fetchApi("Hrlense_PayrollCompany/PayrollCompanyBranch", "POST", payload, null, "Branch added successfully");
        if (response) {
            loadExistingBranches();

            reset({
                company_Id: 0,
                branch_Id: 0,
            });

            setBranches([]);
        }
        setSaving(false);
    };

    // const handleStatusChange = (id: number, value: string) => {
    //     const newStatus = value === "Active";
    //     setStatusChanges((prev) => ({ ...prev, [id]: newStatus }));
    // };

    // const updateStatus = async (id: number) => {
    //     const newStatus = statusChanges[id];
    //     if (newStatus === undefined) {
    //         addToast({ message: "Please change the status before updating.", status: "warning" });
    //         return;
    //     }

    //     setLoadingId(id);

    //     const payload = { id, status: newStatus };

    //     const response = await fetchApi(
    //         "Hrlense_PayrollCompany/PayrollCompanyBranchStatus",
    //         "PUT",
    //         payload,
    //         null,
    //         "Status updated successfully"
    //     );

    //     if (response) {
    //         loadExistingBranches();
    //         setStatusChanges((prev) => {
    //             const updated = { ...prev };
    //             delete updated[id];
    //             return updated;
    //         });
    //     }

    //     setLoadingId(null);
    // };

    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader borderBottomWidth="1px">
                    Add Branch to {payrollCompany?.payrollCompanyName || 'Company'}
                </DrawerHeader>
                <DrawerBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box maxW="400px">
                            <Box mb={6}>
                                <Dropdown isRequired label="Company" name="company_Id" control={control} options={companies} labelKey="company_Name" valueKey="company_ID" errors={errors} />
                            </Box>

                            <Box mb={6}>
                                <Dropdown isRequired label="Branch" name="branch_Id" control={control} options={branches} labelKey="branchName" valueKey="branch_Id" errors={errors} />
                            </Box>
                        </Box>
                        <Flex justify="flex-end">
                            <Button type="submit" isLoading={saving} bg="#006838" color="white" className="font-poppins text_sm text_medium" >
                                Add Branch
                            </Button>
                        </Flex>
                    </form>
                    {tableData.length > 0 && (
                        <Box mt={8}>
                            <Text mb={2} fontWeight="semibold">Existing Branches</Text>
                            <CustomTable value={tableData}>
                                <Column header="S. No" body={(_, idx) => idx + 1} />
                                <Column header="Company Name" field="company_Name" />
                                <Column header="Branch Name" field="branch_Name" />

                            </CustomTable>
                        </Box>
                    )}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
}
